import { fetchConToken } from "../helpers/fetch";
import { types } from "../types/types";
import { startLogout } from "./auth";

export const movementStartLoading = (id) => {

    return async(dispatch) => {

        try{
            const resp = await fetchConToken(`stockmovement/`);
            const body = await resp.json();
            if ( resp.status === 200 && body) {
                dispatch(movementLoaded(body));
            } else {
                if (body?.token === false){
                    dispatch(startLogout());
                }
            }
        } catch (error) {
            console.log(error)
        }
    }
}

const movementLoaded = (movement) => ({
    type: types.movementLoaded,
    payload: movement
});

export const filterMovement = (data) => {

    return async(dispatch) => {

        try{
            const resp = await fetchConToken(`stockmovement`, data);
            const body = await resp.json();
            if (resp.status === 200 && body) {
                dispatch(movementLoaded(body));
            } else {
                if (body?.token === false) {
                    dispatch(startLogout());
                }
            }
        } catch (error) {
            console.log(error);
        }
    }
}